module.exports = __webpack_public_path__ + "static/media/icons.0ab54153.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/icons.woff2
// module id = ./src/styling/theme/assets/fonts/icons.woff2
// module chunks = 0